<template>
    <div id="attendees">
        <div class="row">
            <div class="col-12 mb-4">
                <div
                    class="row align-items-center justify-content-end no-gutters mb-2"
                >
                    <div>
                        <el-tooltip content="Add Attendee" placement="top">
                            <router-link
                                :to="{
                                    name: 'website-types',
                                    params: {
                                        eventId: this.$route.params.eventId
                                    }
                                }"
                            >
                                <el-button> <fa icon="plus" /> </el-button>
                            </router-link>
                        </el-tooltip>
                        <el-tooltip
                            content="Download"
                            placement="top"
                            v-if="
                                user.admin ||
                                    (user.roles &&
                                        user.roles[eventId] &&
                                        user.roles[eventId].downloadReports)
                            "
                        >
                            <el-button
                                @click="downloadList()"
                                :loading="downloading"
                                title="Download"
                            >
                                <fa icon="download" />
                            </el-button>
                        </el-tooltip>
                        <el-tooltip
                            content="Mass E-Mail"
                            placement="top"
                            v-if="
                                user.admin ||
                                    (event.adminRoles &&
                                        event.adminRoles[user._id] &&
                                        event.adminRoles[user._id]
                                            .sendMassEmails)
                            "
                        >
                            <el-button @click="openMassEmailModal">
                                <fa icon="envelope" />
                            </el-button>
                        </el-tooltip>
                        <el-tooltip
                            content="Mass Text"
                            placement="top"
                            v-if="
                                event.enableMassTexts && (user.admin ||
                                    (event.adminRoles &&
                                        event.adminRoles[user._id] &&
                                        event.adminRoles[user._id]
                                            .sendMassTexts))
                            "
                        >
                            <el-button @click="openMassTextModal">
                                <fa icon="sms" />
                            </el-button>
                        </el-tooltip>
                        <el-tooltip
                            
                            content="Scanner Checkin"
                            placement="top"
                            v-if="
                                event.allowScannerCheckin && (user.admin ||
                                    (user.roles &&
                                        user.roles[eventId] &&
                                        user.roles[eventId].checkinRegistrants))
                            "
                        >
                            <router-link
                                :to="{
                                    name: 'scanner',
                                    params: { type: 'registration' }
                                }"
                            >
                                <el-button> <fa icon="camera" /> </el-button>
                            </router-link>
                        </el-tooltip>
                        <el-button
                            v-if="
                                user.admin ||
                                    (user.roles &&
                                        user.roles[eventId] &&
                                        user.roles[eventId].viewRegistrants)
                            "
                            title="Search Using QR"
                            @click="openQrDialongAndCheckPermission"
                        >
                            Search Using QR
                        </el-button>
                    </div>
                </div>
                <el-tooltip v-if="userHasPermissions(['pollRegistrationPrintJobs']) && event.pollRegistrations" :content="true ? 'Disable Polling' : 'Enable Polling'" placement="top">
                    <el-switch :active-text="pollRegistrations ? 'Polling Enabled' : 'Polling Disabled'"
                        class="mb-4" v-model="pollRegistrations" @change="updateRegPollenableStatus" id="polling-switch" />
                </el-tooltip>
                <div class="row">
                    <el-input
                        v-model="filters.confirmationNumber"
                        placeholder="Registration Number"
                        class="col-12 col-sm m-0"
                    />
                    <el-input
                        v-model="filters.name"
                        placeholder="Registrant Name (lastname, firstname)"
                        class="col-12 col-sm m-0"
                    />
                    <el-input
                        v-model="filters.email"
                        placeholder="Registrant E-Mail"
                        class="col-12 col-sm m-0"
                    />
                    <el-input
                        v-model="filters.keywords"
                        class="col-12 col-sm m-0"
                        placeholder="Registrant Global"
                    />
                </div>
                <div class="d-flex justify-content-between">
                    <div class="d-flex justify-content-between" style="gap:20px;">
                        <el-select multiple v-model="filters.status" placeholder="Status">
                            <el-option value="all" label="All">All</el-option>
                            <el-option value="confirmed" label="Confirmed">Confirmed</el-option>
                            <el-option value="pending" label="Pending">Pending</el-option>
                            <el-option value="rejected" label="Rejected">Rejected</el-option>
                            <el-option value="deleted" label="Deleted">Deleted</el-option>
                        </el-select>
                        <el-select multiple v-model="filters.paymentStatus" placeholder="Status">
                            <el-option value="all" label="All">All</el-option>
                            <el-option value="full-payment" label="Fully Paid">Fully Paid</el-option>
                            <el-option value="no-payment" label="Not Paid">Not Paid</el-option>
                            <el-option value="partial-payment" label="Partial Payment">Partial Payment</el-option>
                        </el-select>
                        
                    </div>

                    <div>
                        <el-button
                            id="theSearchButton"
                            class="btn btn-primary"
                            @click="getRegistrations()"
                            style="width: 100px; height: 50px;"
                        >
                            Search
                        </el-button>
                    </div>

                </div>
                <div class="d-flex justify-content-between align-items-center mt-3">
                    <div class="d-flex" style="align-items: center; gap:5px;">
                        <input
                            type="checkbox"
                            style="cursor:pointer"
                            id="primary_only"
                            v-model="filters.primaryOnly"
                            placeholder="primary only"
                        />
                        <label
                            style="margin: 0; cursor: pointer;"
                            for="primary_only"
                            >Primary Registrants only</label
                        >
                    </div>
                    <div class="pt-3" style="font-weight:bold;">
                        Records: {{ total }} of {{ totalWithoutFilter }}
                    </div>
                    
                </div>
                <div class="d-flex justify-content-end">
                    <el-button
                        v-if="filteredByGroup"
                        @click="removeGroupFilter()"
                        style="background-color: #25a5f5 !important; color: #fff !important;"
                        class="mt-1"
                    >
                        Filtered By Group&nbsp; <fa icon="times" />
                    </el-button>
                    <el-button
                        v-if="filteredBySearch"
                        @click="removeSearchFilter()"
                        style="background-color: #FFB236 !important; color: #fff !important;"
                        class="mt-1"
                    >
                        Filtered By Search&nbsp; <fa icon="times" />
                    </el-button>
                </div>
            </div>
            <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>
            <div
                v-for="(registration, index) in registrations"
                :key="`registration-${registration._id}`"
                class="col-md-4 attendee"
                :class="{ 'primary-card': !registration.parent }"
            >
                <card>
                    <div class="d-flex flex-wrap h-100">
                        <div class="w-100">
                            <router-link
                                :to="{
                                    name: 'attendee',
                                    params: { registrationId: registration._id }
                                }"
                            >
                                <h6>{{ registration.name }}</h6>
                            </router-link>
                            <p>{{ registration.confirmationNumber }}</p>
                            <p>{{ registration.email }}</p>
                            <p>{{ registration.type.name }}</p>
                            <p>{{ registration | stateCity }}</p>
                            <p>
                                <el-button
                                    v-if="registration.parent"
                                    size="mini"
                                    class="mt-1"
                                    @click="filterByGroup(registration.parent)"
                                >
                                    <fa icon="users" />
                                </el-button>

                                <el-button
                                    v-else
                                    size="mini"
                                    class="mt-1"
                                    @click="filterByGroup(registration)"
                                >
                                    <fa icon="users" />
                                </el-button>
                                <span
                                    v-if="!registration.parent"
                                    style="display: inline-block; background: purple; color:white; font-size: 0.8rem; padding:3px 10px; margin-left: 12px; border-radius:10px;"
                                >
                                    Primary
                                </span>
                            </p>
                            <el-dropdown
                                trigger="click"
                                @command="performAction"
                            >
                                <span class="el-dropdown-link">
                                    <el-tooltip content="More" placement="top">
                                        <el-button size="mini" title="More">
                                            <fa :icon="['fas', 'ellipsis-v']" />
                                        </el-button>
                                    </el-tooltip>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item
                                        :command="`seeMore-${index}`"
                                        >See More</el-dropdown-item
                                    >
                                    <el-dropdown-item
                                        v-if="
                                        registration.status === 'confirmed' &&
                                                !isCheckedIn(registration) &&
                                                (user.admin ||
                                                    (event.adminRoles &&
                                                        event.adminRoles[
                                                            user._id
                                                        ] &&
                                                        event.adminRoles[
                                                            user._id
                                                        ].checkinRegistrants))
                                        "
                                        :command="`checkin-${index}`"
                                    >
                                        Checkin
                                    </el-dropdown-item>

                                    <el-dropdown-item
                                        v-if="
                                        registration.status === 'confirmed' &&
                                                !registration.parent &&
                                                !isCheckedIn(registration)&&
                                                (user.admin ||
                                                    (event.adminRoles &&
                                                        event.adminRoles[
                                                            user._id
                                                        ] &&
                                                        event.adminRoles[
                                                            user._id
                                                        ].checkinRegistrants))
                                        "
                                        :command="`checkinAll-${index}`"
                                    >
                                        Checkin All
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                        registration.status === 'confirmed' &&
                                                isCheckedIn(registration) &&
                                                (user.admin ||
                                                    (event.adminRoles &&
                                                        event.adminRoles[
                                                            user._id
                                                        ] &&
                                                        event.adminRoles[
                                                            user._id
                                                        ].checkinRegistrants))
                                        "
                                        :command="`removeCheckin-${index}`"
                                    >
                                        Remove Checkin
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                            (registration.status === 'confirmed' ||
                                                registration.status === 'pending') &&
                                                !registration.parent
                                        "
                                        :command="`welcomeEmailLink-${index}`"
                                    >
                                        View Status/Confirmation
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                            (registration.status === 'confirmed' ||
                                                registration.status === 'pending') &&
                                                !registration.parent
                                        "
                                        :command="
                                            `redensConfirmationEmail-${index}`
                                        "
                                    >
                                        Resend confirmation email
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                            event.allowBadgePrintingForAnyStatus ||
                                            (registration.status === 'confirmed' &&
                                                (user.admin ||
                                                    (event.adminRoles &&
                                                        event.adminRoles[
                                                            user._id
                                                        ] &&
                                                        event.adminRoles[
                                                            user._id
                                                        ].checkinRegistrants)))
                                        "
                                        :command="`print-${index}`"
                                    >
                                        Print
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                        (!registration.parent && event.allowBadgePrintingForAnyStatus) ||
                                            (registration.status === 'confirmed' &&
                                                !registration.parent &&
                                                (user.admin ||
                                                    (event.adminRoles &&
                                                        event.adminRoles[
                                                            user._id
                                                        ] &&
                                                        event.adminRoles[
                                                            user._id
                                                        ].checkinRegistrants)))
                                        "
                                        :command="`printAll-${index}`"
                                    >
                                        Print All
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                            !['confirmed'].includes(registration.status) &&
                                            (user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].viewRegistrationTypes)|| (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].allowStatusChanges))
                                        "
                                        :command="
                                            `setStatus-${index}-confirmed`
                                        "
                                    >
                                        Confirm
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                            !registration.parent &&
                                            !['confirmed'].includes(registration.status) &&
                                            (user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].viewRegistrationTypes)|| (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].allowStatusChanges))
                                        "
                                        :command="`setStatus-${index}-confirmed-all`"
                                    >
                                        Confirm All
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                            !registration.parent &&
                                            registration.status !== 'pending' &&
                                            (user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].viewRegistrationTypes)|| (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].allowStatusChanges))
                                        "
                                        :command="`setStatus-${index}-pending-all`"
                                    >
                                        Mark all as Pending
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                            registration.status !== 'pending' &&
                                            (user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].viewRegistrationTypes)|| (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].allowStatusChanges))
                                        "
                                        :command="`setStatus-${index}-pending`"
                                    >
                                        Mark as Pending
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                            registration.status !== 'rejected' &&
                                                (user.admin ||
                                                    (event.adminRoles &&
                                                        event.adminRoles[
                                                            user._id
                                                        ] &&
                                                        event.adminRoles[
                                                            user._id
                                                        ]
                                                            .viewRegistrationTypes))
                                        "
                                        :command="`setStatus-${index}-rejected`"
                                    >
                                        Reject
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                            registration.status !== 'deleted' &&
                                            (user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].viewRegistrationTypes)|| (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].allowStatusChanges))
                                        "
                                        :command="`delete-${index}`"
                                    >
                                        Delete
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                            !registration.parent &&
                                            registration.status !== 'deleted' &&
                                            (user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].viewRegistrationTypes)|| (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].allowStatusChanges))
                                        "
                                        :command="`delete-${index}-all`"
                                    >
                                        Delete All
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="
                                            registration.status === 'deleted' &&
                                                user.admin
                                        "
                                        :command="`permanentDelete-${index}`"
                                    >
                                        Permanent Delete
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div
                            class="d-flex justify-content-between align-items-center align-self-end mt-2"
                        >
                            <div class="d-flex">
                                <div class="mr-1" v-if="activeTab === 'confirmed'">
                                    <el-tag class="border" :class="{ 'bg-warning': registration.status == 'pending', 'bg-primary': registration.status == 'confirmed', 'bg-error': registration.status == 'rejected', 'bgblack': registration.status == 'deleted'  }">
                                        {{ registration.status }}
                                    </el-tag>
                                </div>
                                <div
                                    v-if="
                                        ['pending', 'confirmed'].includes(
                                            activeTab
                                        )
                                    "
                                    class="mr-1"
                                >
                                    <span
                                        v-if="
                                            registration.parent &&
                                                registration.parent._id
                                        "
                                    >
                                        <el-tag
                                            v-if="
                                                registration.parent.total <=
                                                    registration.parent.paid
                                            "
                                            type="success"
                                        >
                                            Paid
                                        </el-tag>
                                        <el-tag
                                            v-else-if="
                                                registration.parent.paid < 1
                                            "
                                            type="danger"
                                        >
                                            Not Paid
                                        </el-tag>
                                        <el-tag v-else type="info">
                                            Partial Payment
                                        </el-tag>
                                    </span>
                                    <span v-else>
                                        <el-tag
                                            v-if="
                                                registration.total <=
                                                    registration.paid
                                            "
                                            type="success"
                                        >
                                            Paid
                                        </el-tag>
                                        <el-tag
                                            v-else-if="registration.paid < 1"
                                            type="danger"
                                        >
                                            Not Paid
                                        </el-tag>
                                        <el-tag v-else type="info">
                                            Partial Payment
                                        </el-tag>
                                    </span>
                                </div>
                                <div
                                    v-if="activeTab === 'confirmed'"
                                    class="mr-1"
                                >
                                    <el-tag
                                        v-if="isCheckedIn(registration)"
                                        type="primary"
                                    >
                                        Checked In
                                    </el-tag>
                                    <el-tag v-else type="warning">
                                        Unchecked
                                    </el-tag>
                                </div>
                                <div v-if="activeTab === 'confirmed'">
                                    <el-tag v-if="registration.printed">
                                        Printed
                                    </el-tag>
                                </div>
                                <div
                                    class="d-flex justify-content-center align-items-center"
                                    style="background: black; font-weight: bold; font-size:0.8rem; height:20px; width:20px; border-radius:50%; color: white;"
                                >
                                    {{ registration.regCount }}
                                </div>
                            </div>
                            <div v-if="activeTab === 'pending'">
                                <el-button-group>
                                    <el-button
                                        @click="
                                            setStatus('confirmed', registration)
                                        "
                                        type="success"
                                        icon="el-icon-success"
                                        size="mini"
                                    />
                                    <el-button
                                        @click="
                                            setStatus('rejected', registration)
                                        "
                                        type="danger"
                                        icon="el-icon-error"
                                        size="mini"
                                    />
                                </el-button-group>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </div>

        <div v-if="total" class="row">
            <div class="col-12 d-flex justify-content-end">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page.sync="page"
                    :total="total"
                    :page-size="perPage"
                >
                </el-pagination>
            </div>
        </div>

        <el-dialog title="Use QR" :visible.sync="useQRDialog">
            <!-- <qrcode-stream @decode="onDecode" v-if="useQRDialog"/> -->
            <qrcode-stream
                :camera="camera"
                @decode="onDecode"
                :track="paintOutline"
                @init="onInit"
                v-if="useQRDialog"
            />
            <div class="d-flex justify-content-center">
                <el-select v-model="camera" clearable placeholder="Select">
                    <el-option
                        v-for="(cam, index) in cameras"
                        :key="cam.deviceId"
                        @click="switchCamera(cam.deviceId)"
                        :label="'Camera ' + (index + 1)"
                        :value="cam.deviceId"
                    >
                    </el-option>
                    <el-option
                        @click="switchCamera('rear')"
                        label="Main Rear Camera"
                        value="rear"
                    >
                    </el-option>
                </el-select>
            </div>
        </el-dialog>

        <el-dialog
            width="70%"
            title="Mass E-Mail"
            :close-on-click-modal="false"
            :visible.sync="massEmailDialog"
        >
            <div v-if="fromNextBtn">
                <div class="d-flex align-items-center mb-3">
                    <div class="filter-grid">
                        <el-select
                            v-model="massEmail.paymentStatus"
                            multiple
                            collapse-tags
                            class="mr-3"
                        >
                            <el-option label="All" :value="null" />
                            <el-option label="Fully Paid" value="full-paid" />
                            <el-option
                                label="Some Payments Made"
                                value="some-paid"
                            />
                            <el-option
                                label="Partial Payment"
                                value="partial-paid"
                            />
                            <el-option label="Not Paid" value="not-paid" />
                        </el-select>
                        <el-select
                            v-model="massEmail.type"
                            multiple
                            collapse-tags
                            class="m-0 p-0"
                        >
                            <el-option label="All" :value="null" />
                            <el-option
                                v-for="t in types"
                                :label="t.name"
                                :value="t._id"
                            />
                        </el-select>
                        <el-select
                            v-model="massEmail.activity"
                            multiple
                            collapse-tags
                            class="m-0 p-0"
                        >
                            <el-option label="All" :value="null" />
                            <el-option
                                v-for="activity in activities"
                                :label="activity.name"
                                :value="activity._id"
                            />
                        </el-select>
                        <div style="display: flex; gap:5px; flex-direction: column;" v-for="(f, i) in fieldsForFilter" :key="f._id">
                            <p style="font-size: smaller; margin: 0;" for="">{{ f.name }}</p>
                            <el-select
                                v-model="fieldValuesAddedToFilter[i]"
                                multiple
                                collapse-tags
                                class="m-0 p-0"
                                @change="handleFieldFilterChange(f, i)"
                                >
                                <el-option label="All" :value="null" />
                                <el-option
                                    v-for="val in f.values.split('\n')"
                                    v-if="val"
                                    :label="val"
                                    :value="val"
                                    @click="handleFieldFilterChange(0,1)"
                                />
                            </el-select>
                        </div>
                    </div>
                    <div class="ml-4">
                        <el-checkbox v-model="massEmail.checkedIn"
                            >Checked In</el-checkbox
                        ><br />
                        <!-- <el-checkbox v-model="massEmail.printed">Printed</el-checkbox> -->
                        <el-checkbox v-model="massEmail.primaryRegistrantsOnly"
                            >Primary Registrants only</el-checkbox
                        ><br />
                    </div>
                </div>
                <div class="form-group">
                    <label>Subject</label>
                    <el-input
                        v-model="massEmail.subject"
                        placeholder="Subject"
                    />
                </div>
                <div class="form-group">
                    <label>Message</label>
                    <Editor v-model="massEmail.message" />
                    <!-- <quill-editor v-model="massEmail.message"/> -->
                </div>
                <div class="d-flex justify-content-left">
                    <ul>
                        <li>
                            Use ${confirmation_number} to display the
                            registration Confirmation Number
                        </li>
                        <li>
                            Use ${total_amt} to display the registration total
                            amount
                        </li>
                        <li>
                            Use ${due_amt} to display the due amount on the
                            registration
                        </li>
                        <li>Use ${registrant_id} to get the registrant Id</li>
                        <li>
                            Use ${registrant_count} to get the registrant count
                        </li>
                        <li>
                            Use ${registrant_type} to get the registrant type
                        </li>
                        <li>
                            Use ${allregistrants.fieldname} to get all info for
                            all registrants
                        </li>
                        <li>Use ${paid_amt} to know the amount paid</li>
                        <li>
                            Use ${registration_created_date} to get registration
                            created date
                        </li>
                    </ul>
                </div>
            </div>
            <div v-else>
                <el-table
                    :data="Object.values(registrantsSelected)"
                    style="max-height:50vh; overflow: auto;"
                    @selection-change="toggleExludeList"
                >
                    <el-table-column
                        type="selection"
                        label="Select" 
                        align="center"
                        width="100%"
                    />
                    <el-table-column
                        label="Confirmation"
                        prop="confirmationNumber"
                    >
                        <template slot-scope="props">
                            <router-link
                                target="_blank"
                                :to="
                                    `/dashboard/${eventId}/attendees/${
                                        props.row._id
                                    }?tab=general_information`
                                "
                                >{{ props.row.confirmationNumber }}</router-link
                            >
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="Name">
                        <template slot-scope="props">
                            {{ props.row.fields.find(f => f.name == "FNAME").value }}
                            {{ props.row.fields.find(f => f.name == "LNAME").value }}
                        </template>
                    </el-table-column>
                    <el-table-column label="Email">
                        <template slot-scope="props">
                            {{ props.row.fields.find(f => f.fieldMapping == "email").value }}
                        </template>
                    </el-table-column>
                    <el-table-column label="Total" prop="total" />
                    <el-table-column label="Paid" prop="paid" />
                    <el-table-column label="Due">
                        <template slot-scope="props">
                            {{ props.row.total - props.row.paid }}
                        </template>
                    </el-table-column>
                    <el-table-column label="Type" prop="type.name" />
                    <el-table-column label="Preview">
                        <template slot-scope="props">
                            <button
                                class="btn btn-primary"
                                @click="openPreviewDialog(props.row)"
                            >
                                preview
                            </button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <template slot="footer">
                <div v-if="fromNextBtn" class="d-flex justify-content-end">
                    <el-checkbox
                        v-model="massEmail.isTestMail"
                        class="mr-3 mt-2"
                        >Send Test E-mail</el-checkbox
                    >
                    <el-input
                        v-model="massEmail.confirmationNumber"
                        placeholder="Conf Number/s (Comma Separated)"
                        class="mr-3 w-25"
                    ></el-input>
                    <el-button
                        class="mr-3"
                        type="primary"
                        :loading="sending"
                        @click="toNextBtn()"
                    >
                        Next
                    </el-button>
                </div>
                <div v-else class="d-flex justify-content-end">
                    <el-button
                        type="primary"
                        :loading="sending"
                        @click="fromNextBtn = true"
                    >
                        Previous
                    </el-button>
                    <el-button
                        v-if="registrantsSelected.length > 0"
                        :disabled="previewDialog"
                        type="primary"
                        :loading="sending"
                        @click="sendEmails()"
                    >
                        Send
                    </el-button>
                </div>
            </template>
        </el-dialog>
        <el-dialog
            width="70%"
            title="Mass Text"
            :close-on-click-modal="false"
            :visible.sync="massTextDialog"
        >
            <div v-if="fromNextBtn">
                <div class="d-flex align-items-center mb-3">
                    <div class="filter-grid">
                        <el-select
                            v-model="massText.paymentStatus"
                            multiple
                            collapse-tags
                            class="mr-3"
                        >
                            <el-option label="All" :value="null" />
                            <el-option label="Fully Paid" value="full-paid" />
                            <el-option
                                label="Some Payments Made"
                                value="some-paid"
                            />
                            <el-option
                                label="Partial Payment"
                                value="partial-paid"
                            />
                            <el-option label="Not Paid" value="not-paid" />
                        </el-select>
                        <el-select
                            v-model="massText.type"
                            multiple
                            collapse-tags
                            class="m-0 p-0"
                        >
                            <el-option label="All" :value="null" />
                            <el-option
                                v-for="t in types"
                                :label="t.name"
                                :value="t._id"
                            />
                        </el-select>
                        <el-select
                            v-model="massText.activity"
                            multiple
                            collapse-tags
                            class="m-0 p-0"
                        >
                            <el-option label="All" :value="null" />
                            <el-option
                                v-for="activity in activities"
                                :label="activity.name"
                                :value="activity._id"
                            />
                        </el-select>
                        <div style="display: flex; gap:5px; flex-direction: column;" v-for="(f, i) in fieldsForFilter" :key="f._id">
                            <p style="font-size: smaller; margin: 0;" for="">{{ f.name }}</p>
                            <el-select
                                v-model="fieldValuesAddedToFilter[i]"
                                multiple
                                collapse-tags
                                class="m-0 p-0"
                                @change="handleFieldFilterChange(f, i)"
                                >
                                <el-option label="All" :value="null" />
                                <el-option
                                    v-for="val in f.values.split('\n')"
                                    v-if="val"
                                    :label="val"
                                    :value="val"
                                    @click="handleFieldFilterChange(0,1)"
                                />
                            </el-select>
                        </div>
                    </div>
                    <div class="ml-4">
                        <el-checkbox v-model="massText.checkedIn"
                            >Checked In</el-checkbox
                        ><br />
                        <!-- <el-checkbox v-model="massText.printed">Printed</el-checkbox> -->
                        <el-checkbox v-model="massText.primaryRegistrantsOnly"
                            >Primary Registrants only</el-checkbox
                        ><br />
                    </div>
                </div>
                <!-- <div class="form-group">
                    <label>Subject</label>
                    <el-input
                        v-model="massText.subject"
                        placeholder="Subject"
                    />
                </div> -->
                <div class="form-group">
                    <label>Message</label>
                    (Approx: {{ textCount }} chars)
                    <!-- <textarea style="width: 100%; padding: 5px; resize: none;" rows="10" v-model="massText.message"></textarea> -->
                    <!-- <Editor v-model="massText.message" @change="updateCharCount" /> -->
                    <quill-editor v-model="massText.message" @change="updateCharCount"/>
                </div>
                <div class="d-flex justify-content-left">
                    <ul>
                        <li>
                            Use ${confirmation_number} to display the
                            registration Confirmation Number
                        </li>
                        <li>
                            Use ${total_amt} to display the registration total
                            amount
                        </li>
                        <li>
                            Use ${due_amt} to display the due amount on the
                            registration
                        </li>
                        <li>Use ${registrant_id} to get the registrant Id</li>
                        <li>
                            Use ${registrant_count} to get the registrant count
                        </li>
                        <li>
                            Use ${registrant_type} to get the registrant type
                        </li>
                        <li>
                            Use ${allregistrants.fieldname} to get all info for
                            all registrants
                        </li>
                        <li>Use ${paid_amt} to know the amount paid</li>
                        <li>
                            Use ${registration_created_date} to get registration
                            created date
                        </li>
                        <li>
                            The Character count is just an aprroximation as we have dynamic fields
                        </li>
                    </ul>
                </div>
            </div>
            <div v-else>
                <el-table
                    :data="Object.values(registrantsSelected)"
                    style="max-height:50vh; overflow: auto;"
                    @selection-change="toggleExludeList"
                >
                    <el-table-column
                        type="selection"
                        label="Select" 
                        align="center"
                        width="100%"
                    />
                    <el-table-column
                        label="Confirmation"
                        prop="confirmationNumber"
                    >
                        <template slot-scope="props">
                            <router-link
                                target="_blank"
                                :to="
                                    `/dashboard/${eventId}/attendees/${
                                        props.row._id
                                    }?tab=general_information`
                                "
                                >{{ props.row.confirmationNumber }}</router-link
                            >
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="Name">
                        <template slot-scope="props">
                            {{ props.row.fields.find(f => f.name == "FNAME").value }}
                            {{ props.row.fields.find(f => f.name == "LNAME").value }}
                        </template>
                    </el-table-column>
                    <el-table-column label="Phone">
                        <template slot-scope="props">
                            {{ getPhoneFromFields(props.row.fields) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="Formatted Phone" prop="formattedPhone" />
                    <el-table-column label="Total" prop="total" />
                    <el-table-column label="Paid" prop="paid" />
                    <el-table-column label="Due">
                        <template slot-scope="props">
                            {{ props.row.total - props.row.paid }}
                        </template>
                    </el-table-column>
                    <el-table-column label="Type" prop="type.name" />
                    <el-table-column label="Preview">
                        <template slot-scope="props">
                            <button
                                class="btn btn-primary"
                                @click="openTextPreviewDialog(props.row)"
                            >
                                preview
                            </button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <template slot="footer">
                <div v-if="fromNextBtn" class="d-flex justify-content-end">
                    <el-checkbox
                        v-model="massText.isTest"
                        class="mr-3 mt-2"
                        >Send Test Text</el-checkbox
                    >
                    <el-input
                        v-model="massText.confirmationNumber"
                        placeholder="Conf Number/s (Comma Separated)"
                        class="mr-3 w-25"
                    ></el-input>
                    <el-button
                        class="mr-3"
                        type="primary"
                        :loading="sending"
                        @click="toNextBtnText()"
                    >
                        Next
                    </el-button>
                </div>
                <div v-else class="d-flex justify-content-end">
                    <el-button
                        type="primary"
                        :loading="sending"
                        @click="fromNextBtn = true"
                    >
                        Previous
                    </el-button>
                    <el-button
                        v-if="registrantsSelected.length > 0"
                        :disabled="previewDialog"
                        type="primary"
                        :loading="sending"
                        @click="sendTexts()"
                    >
                        Send
                    </el-button>
                </div>
            </template>
        </el-dialog>

        <el-dialog
            title="Preview Email"
            :close-on-click-modal="false"
            :visible.sync="previewDialog"
        >
            <div v-html="html"></div>
        </el-dialog>
    </div>
</template>

<script>
import swal from "sweetalert2";
import http from "../../http";
import moment from "moment";
import _ from "lodash";
import { mapState } from "vuex";
import download from "downloadjs";
import dymoXml from "../../assets/js/dymoXml";
import { QrcodeStream } from "@jyotirmay/vue-qrcode-reader-extended";
import Editor from "../../components/Editor.vue";
import { event } from "jquery";
import { htmlToText } from 'html-to-text';
import { update } from "lodash";

const emptyMassEmail = () => {
    return {
        subject: "",
        message: "",
        paymentStatus: [],
        type: [],
        activity: [],
        checkedIn: false,
        printed: false,
        isTestMail: false,
        confirmationNumber: null,
        primaryRegistrantsOnly: false
    };
};
const emptyMassText = () => {
    return {
        message: "",
        paymentStatus: [],
        type: [],
        activity: [],
        checkedIn: false,
        printed: false,
        isTest: false,
        confirmationNumber: null,
        primaryRegistrantsOnly: false
    }
};

const emptyFilters = () => {
    return {
        id: "",
        primaryOnly: false,
        confirmationNumber: "",
        name: "",
        email: "",
        keywords: "",
        parent: "",
        status: ["confirmed", "pending"],
        paymentStatus: ["all" ],
    };
};

export default {
    components: {
        QrcodeStream,
        Editor
    },
    data() {
        return {
            loading: false,
            activeTab: "confirmed",
            registrations: [],
            filteredRegistrations: [],
            massEmailDialog: false,
            useQRDialog: false,
            massEmail: emptyMassEmail(),
            sending: false,
            downloading: false,
            filteredByGroup: false,
            filteredBySearch: false,
            isParent: {},
            page: 1,
            perPage: 30,
            filters: emptyFilters(),
            total: null,
            totalWithoutFilter: null,
            eventId: null,
            stream: null,
            camera: "rear",
            cameras: [],
            fromNextBtn: true,
            registrantsSelected: [],
            registrantsToBeExcluded: [],
            registrantIncluded: true,
            previewDialog: false,
            html: "",
            fieldsForFilter: [],
            fieldValuesAddedToFilter:[],
            fieldMatches: {},
            checkinData:{},

            massTextDialog: false,
            massText: emptyMassText(),
            textCount: 0,
            pollRegistrations: false
        };
    },
    computed: {
        ...mapState(["user", "types", "event", "activities"])
    },
    watch: {
        page: "getRegistrations",
        useQRDialog(nv) {
            if (!nv) this.stopMediaStram();
        }
    },
    async mounted() {
        if (this.$route.query.parent && this.$route.query.parent.length) {
            this.filterByGroup({ _id: this.$route.query.parent });
        }

        const cnf = this.$route.query.confirmationNumber;

        if(cnf){
            this.filters.confirmationNumber = cnf;
        }

        this.getRegistrations();
        this.getAdditionalData();
        this.eventId = this.$route.params.eventId;
        this.fieldsForFilter = (await http.get(`/api/fields-for-filters/${this.eventId}`)).data.fields;

        const theSearchButton = document.getElementById('theSearchButton');
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter'){
                theSearchButton.click();
            }
        })
        
        let pollRegistrations = false;

        if (
        this.user &&
        this.user.polling &&
        this.event &&
        this.event._id &&
        this.user.polling[this.event._id]
        ) {
        pollRegistrations =
            this.user.polling[this.event._id].registrations === true;
        }

        this.pollRegistrations = pollRegistrations;
    },
    methods: {
        userHasPermissions(permissions) {
            if (this.user.admin) return true;
            const roles = this.event.adminRoles && this.user._id && this.event.adminRoles[this.user._id] ? this.event.adminRoles[this.user._id] : []
            let valid = true
            permissions.forEach(per => {
                if (!roles[per]) valid = false;
            })
            return valid;
        },
        async updateRegPollenableStatus(){
            try {
                // await http.put(`/api/events/${this.eventId}/update-reg-poll-status`, { pollRegistrations: this.pollRegistrations });
                await http.put(`/api/update-user-poll-status`, { registrations: this.pollRegistrations, eventId: this.event._id });
                await this.$store.dispatch('getUser')
                this.$notify("Registration Polling status updated successfully", "success")
            } catch (error) {
                console.log(error);
                
                this.pollRegistrations = !this.pollRegistrations
                this.$notify({
                    type: 'danger',
                    message: "Something went wrong !"
                })
            }
        },
        getPhoneFromFields(fields){
          let phoneField = fields.find(f => f.fieldMapping === 'phone');
          if(!phoneField) phoneField = fields.find(field => field.name === 'PHONE')
          if(phoneField) return phoneField.value
          return "N/A"
        },
        updateCharCount(){
            const plain = htmlToText(this.massText.message, {
                wordwrap: false,
                selectors: [
                    { selector: 'a', options: { ignoreHref: true } }
                ]
            });
            this.textCount = Array.from(plain).length

        },
        isCheckedIn(reg) {
            return (this.checkinData[reg._id] != undefined ? this.checkinData[reg._id] : reg.checkedIn)
        },

        handleFieldFilterChange(field, i) {
            this.fieldMatches[field._id] = this.fieldValuesAddedToFilter[i];
            Object.keys(this.fieldMatches).forEach(key => {
                if(this.fieldMatches[key].length == 0){
                    delete this.fieldMatches[key];
                }
            })
        },
        async openQrDialongAndCheckPermission() {
            // for camera detection
            this.stream = await navigator.mediaDevices.getUserMedia({
                audio: false,
                video: true
            });
            const devices = await navigator.mediaDevices.enumerateDevices();
            this.cameras = devices.filter(device =>
                ["videoinput"].includes(device.kind)
            );

            this.useQRDialog = true;
        },
        async stopMediaStram() {
            if (this.stream) {
                this.stream.getTracks().forEach(track => track.stop());
            }
        },
        getRegistrations: async function() {
            this.loading = true;
            try {
                if (
                    this.filters.confirmationNumber ||
                    this.filters.name ||
                    this.filters.email ||
                    this.filters.keywords
                ) {
                    this.filteredBySearch = true;
                    if (this.filteredByGroup) this.filteredByGroup = false;
                }
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                const response = await this.$store.dispatch("getAll", {
                    path: "registrations",
                    params: {
                        page: this.page,
                        perPage: this.perPage,
                        select:
                            "confirmationNumber paid total printed event status checkedInDate fields.fieldMapping fields.value registeredAttendees checkedInAttendees ",
                        filters: {
                            ...this.filters,
                            eventId: this.$route.params.eventId,
                            populateParent: {
                                select:
                                    "confirmationNumber paid total fields.fieldMapping fields.value "
                            },
                            populateType: { select: "name fields " },
                            populateFieldBasedActivities: {
                                select: "name badgeCode "
                            },
                            populateRegisteredActivities: {
                                select: "name badgeCode "
                            }
                        }
                    }
                });

                this.total = response.data.total ? response.data.total : 0;
                this.totalWithoutFilter = response.data.totalWithoutFilter
                    ? response.data.totalWithoutFilter
                    : 0;

                const registrations = response.data.registrations.map(
                    registration => {
                        let name = "";
                        let email = "";
                        let firstName = registration.fields.find(
                            field => field.fieldMapping === "firstName"
                        );
                        let lastName = registration.fields.find(
                            field => field.fieldMapping === "lastName"
                        );
                        let emailMapping = registration.fields.find(
                            field => field.fieldMapping === "email"
                        );

                        if (firstName) name = firstName.value + " ";
                        if (lastName) name += lastName.value;
                        if (emailMapping) email = emailMapping.value;

                        registration.name = name;
                        registration.email = email;

                        if (registration.parent && registration.parent._id) {
                            this.$set(
                                this.isParent,
                                registration.parent._id,
                                true
                            );
                        }

                        return registration;
                    }
                );

                this.registrations = registrations;
            } catch (e) {
                console.log(e);
                console.log("erorr getting registrations");
            }
            this.loading = false;
        },
        getAdditionalData: async function() {
            try {
                await Promise.all([
                    this.$store.dispatch("getAll", {
                        path: "types",
                        params: {
                            filters: { eventId: this.$route.params.eventId }
                        }
                    }),
                    this.$store.dispatch("getAll", {
                        path: "activities",
                        params: {
                            filters: { eventId: this.$route.params.eventId }
                        }
                    })
                ]);
                // await this.fetchCheckins();
            } catch (e) {
                console.log(e);
                console.log("error getting additional data");
            }
        },
        performAction: function(command) {
            //console.log('@@performAction', this.registrations, command)
            command = command.split("-");
            const registration = this.registrations[command[1]];
            // let registrationGroup = [];
            // registrationGroup = this.registrations.filter(item=>{
            //     if(item.parent && registration._id == item.parent._id)
            //         return item
            // })
            switch (command[0]) {
                case "seeMore":
                    this.$router.push({
                        name: "attendee",
                        params: { registrationId: registration._id }
                    });
                    break;
                case "checkin":
                    this.checkin(registration, command[1]);
                    break;
                case "checkinAll":
                    this.checkin(registration, command[1], true);
                    break;
                case "removeCheckin":
                    this.removeCheckin(registration, command[1]);
                    break;
                case "edit":
                    this.$router.push({
                        name: "registration-edit",
                        params: {
                            eventId: registration.event,
                            id: registration._id
                        }
                    });
                    break;
                case "welcomeEmailLink":
                    window.open(`/welcome-email/${registration._id}`);
                    break;
                case "redensConfirmationEmail":
                    this.resendConfirmationEmail(registration);
                    break;
                case "print":
                    // this.$router.push({ name: 'print', params: { registrationId: registration._id } })
                    this.print(registration);
                    this.createPrintLog(registration);
                    break;
                case "printAll":
                    // registrationGroup.push(registration)
                    // for( let i=0; i<registrationGroup.length; i++){
                    //     this.print(registrationGroup[i])
                    // }
                    this.registrations.filter(item => {
                        if (item.parent && registration._id == item.parent._id)
                            this.print(item);
                    });
                    this.print(registration);
                    this.createPrintLog(registration, true);
                    break;
                case "setStatus":
                    if(command[3] && command[3] == 'all'){
                        this.setStatus(command[2], registration, true);
                    }else{
                        this.setStatus(command[2], registration);
                    }
                    break;
                case "delete":
                    if(command[2] && command[2] == 'all'){
                        this.setStatus("deleted", registration, true);
                    }else{
                        this.setStatus("deleted", registration);
                    }
                    break;
                case "permanentDelete":
                    this.removeRegistration(registration._id);
                    break;
            }
        },
        checkin: async function(registration, index, isCheckInAll = false) {
            try {
                const res = await this.$store.dispatch("checkin", {
                    type: "registration",
                    id: registration._id,
                    checkinBy: this.user,
                    isCheckInAll,
                    eventId: this.$route.params.eventId,
                    method: "manual"
                });                
                // await this.fetchCheckins();
                this.filterRegistrations();
                // this.registrations[index].checkedIn = true
                if(isCheckInAll){
                    res.data.allCheckins.forEach(ch => {
                        this.checkinData[ch.registration] = {
                            ...ch,
                        }
                    })
                }
                else {
                    this.checkinData[res.data.checkin.registration] = {
                        ...res.data.checkin,
                    }                    
                }
                this.checkinData = {
                    ...this.checkinData
                }

                this.$notify(res.data.message);
            } catch (error) {
                console.log(error);
            }
        },
        removeCheckin: async function(registration, index) {
            const checkinId = this.checkinData[registration._id] ? this.checkinData[registration._id]._id : registration.checkinId;
            if (checkinId) {
                try {
                    await http.delete(`/api/checkin/registration/${checkinId}`).catch(
                        e => {
                            console.log(e);
                            console.log("error removing checkin from registration");
                            this.$store.dispatch("handleErrors", e);
                        }
                    );
                    this.checkinData[registration._id] = false
                    this.checkinData = {
                        ...this.checkinData
                    }
                } catch (error) {
                    console.log(error);
                }
                
                // let newRegistrations = [...this.registrations];
                // delete newRegistrations[index].checkedInDate;
                // this.registrations = newRegistrations;
                // this.filterRegistrations();
                // await this.fetchCheckins();
                
            }
        },
        removeRegistration: async function(id) {
            try {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete this registration?`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: "OK",
                    cancelButtonText: "Cancel",
                    confirmButtonClass: "btn btn-success btn-fill",
                    cancelButtonClass: "btn btn-default btn-fill"
                });

                if (confirmed) {
                    this.registrations = this.registrations.filter(
                        registration => registration._id !== id
                    );
                    this.filterRegistrations();
                    this.$store.dispatch("remove", {
                        path: "registrations",
                        id
                    });
                }
            } catch (e) {
                console.log(e);
                console.log("error deleting registration");
            }
        },
        setStatus: async function(status, registration, forAll = false) {
            try {
                await http.put(`/api/registrations/update-status-only`, {
                    confirmationNumber: registration.confirmationNumber,
                    id: registration._id,
                    status,
                    eventId: this.eventId,
                    forAll
                })

                registration.status = status;

                if (forAll) {
                    this.registrations.filter(item => {
                        if (item.parent && registration._id == item.parent._id) return (item.status = status);  
                    });
                }

                this.filterRegistrations();
            } catch (error) {
                this.$notify({
                    type: 'danger',
                    message: "Something went wrong !"
                })
            }
            
        },
        resendConfirmationEmail: async function(registration) {
            try {
                await http.post(
                    `/api/registrations/${
                        registration._id
                    }/resend-confirmation-email?host=${
                        window.location.protocol
                    }//${window.location.host}`
                );
                this.$notify("Confirmation email resent successfully!");
            } catch (e) {
                this.$store.dispatch("handleErrors", e);
                console.log("error on resend confirmation email");
            }
        },
        filterRegistrations: function(debounce = false) {
            const filter = () => {
                let registrations = this.registrations.filter(registration => {
                    if (registration.status !== this.activeTab) {
                        return false;
                    }

                    if (
                        this.filters.confirmationNumber.length &&
                        (!registration.confirmationNumber ||
                            registration.confirmationNumber
                                .toUpperCase()
                                .indexOf(
                                    this.filters.confirmationNumber.toUpperCase()
                                ) === -1)
                    ) {
                        return false;
                    }

                    if (
                        this.filters.id.length &&
                        registration._id
                            .toUpperCase()
                            .indexOf(this.filters.id.toUpperCase()) === -1
                    ) {
                        return false;
                    }

                    if (
                        this.filters.name.length &&
                        registration.name
                            .toUpperCase()
                            .indexOf(this.filters.name.toUpperCase()) === -1
                    ) {
                        return false;
                    }

                    if (
                        this.filters.email.length &&
                        registration.email
                            .toUpperCase()
                            .indexOf(this.filters.email.toUpperCase()) === -1
                    ) {
                        return false;
                    }

                    if (
                        this.filters.keywords.length &&
                        registration.keywords &&
                        registration.keywords
                            .toUpperCase()
                            .indexOf(this.filters.keywords.toUpperCase()) === -1
                    ) {
                        return false;
                    }

                    if (this.filters.parent.length) {
                        if (registration.parent) {
                            if (
                                registration.parent._id !== this.filters.parent
                            ) {
                                return false;
                            }
                        } else {
                            if (registration._id !== this.filters.parent) {
                                return false;
                            }
                        }
                    }

                    return true;
                });

                this.filteredRegistrations = registrations;
            };

            if (debounce) {
                let delay = _.debounce(() => {
                    filter();
                }, 300);
                delay();
            } else {
                filter();
            }
        },
        openMassEmailModal() {
            this.massEmailDialog = true;
            this.fromNextBtn = true;
            this.registrantsToBeExcluded = [];
        },
        openMassTextModal() {
            this.massTextDialog = true;
            this.fromNextBtn = true;
            this.registrantsToBeExcluded = [];
        },
        toggleExludeList: async function(registrations) {
            this.registrantsToBeExcluded = [];

            const idsToInclude = registrations.map(registration => {
                return registration._id;
            });

            this.registrantsSelected.forEach(reg =>{
                if(!idsToInclude.includes(reg._id)){
                    this.registrantsToBeExcluded.push({
                        confirmationNumber: reg.confirmationNumber,
                        email: reg.fields[3].value,
                        _id: reg._id
                    });
                }
            })
        },
        toNextBtn: async function() {
            this.sending = true;
            try {
                let res = await http.post("/api/mass-email", {
                    ...this.massEmail,
                    eventId: this.$route.params.eventId,
                    fromNextBtn: true,
                    fieldMatches: this.fieldMatches
                });
                this.registrantsSelected = res.data.registrations;
                this.fromNextBtn = false;
                setTimeout(()=>{
                    document.querySelector('th.el-table-column--selection .el-checkbox input').click()
                }, 500)
            } catch (e) {
                console.log(e);
                console.log("error sending mass email");
                this.$store.dispatch("handleErrors", e);
            }
            this.sending = false;
        },
        toNextBtnText: async function() {
            this.sending = true;
            try {
                let res = await http.post("/api/mass-text", {
                    ...this.massText,
                    eventId: this.$route.params.eventId,
                    fromNextBtn: true,
                    fieldMatches: this.fieldMatches
                });
                this.registrantsSelected = res.data.registrations;
                this.fromNextBtn = false;
                setTimeout(()=>{
                    document.querySelector('th.el-table-column--selection .el-checkbox input').click()
                }, 500)
            } catch (e) {
                console.log(e);
                console.log("error sending mass text");
                this.$store.dispatch("handleErrors", e);
            }
            this.sending = false;
        },
        sendEmails: async function() {
            this.sending = true;
            try {
                await http.post("/api/mass-email", {
                    ...this.massEmail,
                    fieldMatches: this.fieldMatches,
                    eventId: this.$route.params.eventId,
                    registrantsToBeExcludedFromMassEmail: this
                        .registrantsToBeExcluded
                });
                this.$notify("E-Mails successfully sent!");
                this.massEmailDialog = false;
                this.massEmail = emptyMassEmail();
            } catch (e) {
                console.log(e);
                console.log("error sending mass email");
                this.$store.dispatch("handleErrors", e);
            }
            this.sending = false;
        },
        sendTexts: async function() {
            this.sending = true;
            try {
                await http.post("/api/mass-text", {
                    ...this.massText,
                    fieldMatches: this.fieldMatches,
                    eventId: this.$route.params.eventId,
                    registrantsToBeExcludedFromMassTexts: this
                        .registrantsToBeExcluded
                });
                this.$notify("Texts successfully sent!");
                this.massTextDialog = false;
                this.massEmail = emptyMassText();
            } catch (e) {
                console.log(e);
                console.log("error sending mass texts");
                this.$store.dispatch("handleErrors", e);
            }
            this.sending = false;
        },
        async openPreviewDialog(registration) {
            this.html = await this.generateEmailForRegistration(
                this.massEmail.message,
                registration
            );
            this.previewDialog = true;
        },
        async openTextPreviewDialog(registration) {
            this.html = await this.generateEmailForRegistration(
                this.massText.message,
                registration
            );
            this.previewDialog = true;
        },
        async generateEmailForRegistration(html, registration) {
            for (let i = 0; i < registration.fields.length; i++) {
                let field = registration.fields[i];

                let foundAllregistrants = html.search(
                    new RegExp(`allregistrants.${field.name}`, "g")
                );

                if (foundAllregistrants > 0) {
                    const values = await this.getAllFieldRelatedValues(
                        field.name,
                        registration
                    );
                    html = html.replace(
                        new RegExp(`allregistrants.${field.name}`, "g"),
                        values
                    );
                }

                if (field.type === "checkboxes") {
                    let text = "";

                    field.value.forEach(value => {
                        text +=
                            field.labels.split("\n")[
                                field.values.split("\n").indexOf(value)
                            ] + " ";
                    });

                    html = html.replace(new RegExp(field.name, "g"), text);
                } else if (field.type === "radio" || field.type === "list") {
                    html = html.replace(
                        new RegExp(field.name, "g"),
                        field.labels.split("\n")[
                            field.values.split("\n").indexOf(field.value)
                        ]
                    );
                } else {
                    html = html.replace(
                        new RegExp(field.name, "g"),
                        field.value
                    );
                }
            }

            // replace total & due fields
            html = html.replace(
                new RegExp("total_amt", "g"),
                registration.total.toFixed(2)
            );
            html = html.replace(
                new RegExp("due_amt", "g"),
                (registration.total - registration.paid).toFixed(2)
            );
            html = html.replace(
                new RegExp("registrant_id", "g"),
                registration._id
            );
            html = html.replace(
                new RegExp("confirmation_number", "g"),
                registration.confirmationNumber
            );
            html = html.replace(
                new RegExp("registrant_count", "g"),
                registration.regCount
            );
            html = html.replace(
                new RegExp("registrant_type", "g"),
                registration.type.name
            );
            html = html.replace(new RegExp("paid_amt", "g"), registration.paid);
            html = html.replace(
                new RegExp("registration_created_date", "g"),
                moment(registration.createdAt).format("DD MMM YYYY HH:mm")
            );

            if (registration.event && registration.event._id) {
                html = html.replace(
                    new RegExp("EVENTSCODED_REG_TOTAL_AMT", "g"),
                    registration.event.totalRegistrations
                );
                html = html.replace(
                    new RegExp("EVENTSCODED_REG_PAID_AMT", "g"),
                    registration.event.totalPaid
                );
            }

            html = html.replace(/\$|{|}/g, "");

            return html;
        },
        async getAllFieldRelatedValues(fieldName, registration) {
            let htmlStr = "";
            const allRegistrants = (await http.get(
                `/api/registrations/all-by-confirmation-number/${
                    registration.confirmationNumber
                }/${this.$route.params.eventId}`
            )).data.registrations;

            allRegistrants.sort((a, _) => {
                if (a.parent) {
                    return 1;
                }
                return -1;
            });

            for (let i = 0; i < allRegistrants.length; i++) {
                htmlStr += `<span>${await this.generateEmailForRegistration(
                    fieldName,
                    allRegistrants[i]
                )}</span>`;
            }

            htmlStr = `<span style="display: inline-flex; flex-direction: column; gap:10px;">${htmlStr}</span>`;

            return htmlStr;
        },
        downloadList: async function() {
            this.downloading = true;
            try {
                const response = await http.post(
                    "/api/registrations/download",
                    {
                        registrationIds: this.registrations.map(
                            registration => registration._id
                        )
                    },
                    {
                        responseType: "arraybuffer"
                    }
                );
                download(
                    response.data,
                    "attendees.xlsx",
                    "	application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                );
            } catch (e) {
                this.$store.dispatch("handleErrors", e);
                console.log("error downloading list");
            }
            this.downloading = false;
        },
        filterByGroup: function(parent) {

            let prevStatusFilter = this.filters.status
            this.filters = emptyFilters();
            this.filters.status = prevStatusFilter

            this.filteredByGroup = true;
            if (this.filteredBySearch) this.filteredBySearch = false;
            this.filters.parent = parent._id;
            this.getRegistrations();
        },
        removeGroupFilter: function() {
            this.filteredByGroup = false;
            this.filters.parent = "";
            this.getRegistrations();
        },
        removeSearchFilter: function() {
            this.filteredBySearch = false;

            let prevStatusFilter = this.filters.status
            this.filters = emptyFilters();
            this.filters.status = prevStatusFilter
            
            this.getRegistrations();
        },
        async createPrintLog(registration, all = false) {
            await http.post("/api/registrations/print-log", {
                confirmationNumber: registration.confirmationNumber,
                registrantId: registration._id,
                all,
                printedBy: this.user
            });
        },
        print: function(registration) {
            let confirNumActivityCode = [];
            if (
                registration.confirmationNumber &&
                this.event.includeConfirmationNumberOnBadge
            )
                confirNumActivityCode.push(registration.confirmationNumber);
            let allActivityArr = [
                ...registration.registeredActivities,
                ...registration.fieldBasedActivities
            ]
                .map(item => item.badgeCode)
                .filter(el => el);
            if (
                allActivityArr.length &&
                this.event.displayCodeOnBadgeForActivities
            )
                confirNumActivityCode.push(...allActivityArr);

            let title = registration.fields.find(
                field => field.fieldMapping === "title"
            );
            registration.type.fields.filter((field, index) => {
                if (field.fieldMapping === "title")
                    title =
                        !title &&
                        registration.fields.length ==
                            registration.type.fields.length
                            ? registration.fields[index]
                            : title;
            });
            title = title ? title.value : "";

            let firstName = registration.fields.find(
                field => field.fieldMapping === "firstName"
            );
            firstName = firstName ? firstName.value : "";
            let lastName = registration.fields.find(
                field => field.fieldMapping === "lastName"
            );
            lastName = lastName ? lastName.value : "";

            let state = registration.fields.find(
                field => field.fieldMapping === "state"
            );
            state = state ? state.value : "";
            if (state == "" && registration.parent) {
                let parentState = registration.parent.fields.find(
                    field => field.fieldMapping === "state"
                );
                let parentTypeState = registration.parent.type.fields.find(
                    field => field.fieldMapping === "state"
                );
                state =
                    parentState && parentTypeState.pullParentDataIfNotAvailable
                        ? parentState.value
                        : "";
            }
            let city = registration.fields.find(
                field => field.fieldMapping === "city"
            );
            city = city ? city.value : "";
            if (city == "" && registration.parent) {
                let parentCity = registration.parent.fields.find(
                    field => field.fieldMapping === "city"
                );
                let parentTypeCity = registration.parent.type.fields.find(
                    field => field.fieldMapping === "city"
                );
                city =
                    parentCity && parentTypeCity.pullParentDataIfNotAvailable
                        ? parentCity.value
                        : "";
            }
            //console.log(dymo)
            dymo.label.framework.trace = true;
            dymo.label.framework.init(() => {
                const printers = dymo.label.framework.getPrinters();

                if (!printers.length) {
                    console.log("no supported printers found");
                    return;
                }

                console.log("Printers: ", printers)

                const labelXml = `<?xml version="1.0" encoding="utf-8"?>
                                    <DieCutLabel Version="8.0" Units="twips">
                                        <PaperOrientation>Landscape</PaperOrientation>
                                        <Id>ZipDisk</Id>
                                        <IsOutlined>false</IsOutlined>
                                        <PaperName>30370 Zip Disk</PaperName>
                                        <DrawCommands>
                                            <RoundRectangle X="0" Y="0" Width="2880" Height="3375" Rx="270" Ry="270" />
                                        </DrawCommands>
                                        <ObjectInfo>
                                            <TextObject>
                                                <Name>TEXT</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <HorizontalAlignment>Center</HorizontalAlignment>
                                                <VerticalAlignment>Top</VerticalAlignment>
                                                <TextFitMode>ShrinkToFit</TextFitMode>
                                                <UseFullFontHeight>True</UseFullFontHeight>
                                                <Verticalized>False</Verticalized>
                                                <StyledText>
                                                    <Element>
                                                        <String xml:space="preserve">${city.toUpperCase()}</String>
                                                        <Attributes>
                                                            <Font Family="Britannic" Size="14" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                                        </Attributes>
                                                    </Element>
                                                </StyledText>
                                            </TextObject>
                                            <Bounds X="344" Y="1527" Width="1764" Height="311.999999999999" />
                                        </ObjectInfo>
                                        <ObjectInfo>
                                            <BarcodeObject>
                                                <Name>BARCODE</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <Text>${registration._id}</Text>
                                                <Type>QRCode</Type>
                                                <Size>Large</Size>
                                                <TextPosition>None</TextPosition>
                                                <TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <TextEmbedding>None</TextEmbedding>
                                                <ECLevel>0</ECLevel>
                                                <HorizontalAlignment>Center</HorizontalAlignment>
                                                <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
                                            </BarcodeObject>
                                            <Bounds X="2163" Y="1395" Width="1095" Height="1044" />
                                        </ObjectInfo>
                                        <ObjectInfo>
                                            <ShapeObject Stroke="SolidLine">
                                                <Name>SHAPE</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <ShapeType>HorizontalLine</ShapeType>
                                                <LineWidth>15</LineWidth>
                                                <LineAlignment>Center</LineAlignment>
                                                <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
                                            </ShapeObject>
                                            <Bounds X="317" Y="1350" Width="2775" Height="15" />
                                        </ObjectInfo>
                                        <ObjectInfo>
                                            <TextObject>
                                                <Name>TEXT_1</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <HorizontalAlignment>Center</HorizontalAlignment>
                                                <VerticalAlignment>Top</VerticalAlignment>
                                                <TextFitMode>ShrinkToFit</TextFitMode>
                                                <UseFullFontHeight>True</UseFullFontHeight>
                                                <Verticalized>False</Verticalized>
                                                <StyledText>
                                                    <Element>
                                                        <String xml:space="preserve">${title} ${firstName.toUpperCase()}</String>
                                                        <Attributes>
                                                            <Font Family="Britannic" Size="24" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                                        </Attributes>
                                                    </Element>
                                                </StyledText>
                                            </TextObject>
                                            <Bounds X="317" Y="195" Width="2851" Height="497.999999999999" />
                                        </ObjectInfo>
                                        <ObjectInfo>
                                            <TextObject>
                                                <Name>TEXT_2</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <HorizontalAlignment>Center</HorizontalAlignment>
                                                <VerticalAlignment>Top</VerticalAlignment>
                                                <TextFitMode>ShrinkToFit</TextFitMode>
                                                <UseFullFontHeight>True</UseFullFontHeight>
                                                <Verticalized>False</Verticalized>
                                                <StyledText>
                                                    <Element>
                                                        <String xml:space="preserve">${lastName.toUpperCase()}</String>
                                                        <Attributes>
                                                            <Font Family="Britannic" Size="20" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                                        </Attributes>
                                                    </Element>
                                                </StyledText>
                                            </TextObject>
                                            <Bounds X="317" Y="843.000000000001" Width="2805" Height="366" />
                                        </ObjectInfo>
                                        <ObjectInfo>
                                            <TextObject>
                                                <Name>TEXT_3</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <HorizontalAlignment>Center</HorizontalAlignment>
                                                <VerticalAlignment>Top</VerticalAlignment>
                                                <TextFitMode>ShrinkToFit</TextFitMode>
                                                <UseFullFontHeight>True</UseFullFontHeight>
                                                <Verticalized>False</Verticalized>
                                                <StyledText>
                                                    <Element>
                                                        <String xml:space="preserve">${state.toUpperCase()}</String>
                                                        <Attributes>
                                                            <Font Family="Britannic" Size="14" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                                        </Attributes>
                                                    </Element>
                                                </StyledText>
                                            </TextObject>
                                            <Bounds X="317" Y="1983" Width="1798" Height="357" />
                                        </ObjectInfo>
                                        <ObjectInfo>
                                            <TextObject>
                                                <Name>TEXT_4</Name>
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                                <LinkedObjectName />
                                                <Rotation>Rotation0</Rotation>
                                                <IsMirrored>False</IsMirrored>
                                                <IsVariable>False</IsVariable>
                                                <GroupID>-1</GroupID>
                                                <IsOutlined>False</IsOutlined>
                                                <HorizontalAlignment>Center</HorizontalAlignment>
                                                <VerticalAlignment>Top</VerticalAlignment>
                                                <TextFitMode>ShrinkToFit</TextFitMode>
                                                <UseFullFontHeight>True</UseFullFontHeight>
                                                <Verticalized>False</Verticalized>
                                                <StyledText>
                                                    <Element>
                                                        <String xml:space="preserve">${confirNumActivityCode.join(
                                                            "|"
                                                        )}</String>
                                                        <Attributes>
                                                            <Font Family="Century Gothic" Size="12" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                                        </Attributes>
                                                    </Element>
                                                </StyledText>
                                            </TextObject>
                                            <Bounds X="317" Y="2494" Width="2835" Height="165" />
                                        </ObjectInfo>
                                    </DieCutLabel>`;
                //console.log('@@labelXml', labelXml)
                const label = dymo.label.framework.openLabelXml(labelXml);
                label.print("DYMO LabelWriter 450");
            });
        },
        onDecode: async function(decodedString) {
            if (!decodedString || !decodedString.length) {
                return;
            }
            try {
                const response = await this.$store.dispatch("get", {
                    path: "registrations",
                    id: decodedString
                });
                const registration = response.data.registration;
                if (registration && registration.event._id == this.event._id) {
                    this.filters.confirmationNumber =
                        registration.confirmationNumber;
                    this.getRegistrations();
                    this.useQRDialog = false;
                } else {
                    this.$notify({
                        type: "danger",
                        message: "Registrant Invalid OR NOT Registered"
                    });
                }
            } catch (e) {
                this.$notify({
                    type: "danger",
                    message: "Registrant Invalid OR NOT Registered"
                });
                console.log(e);
                console.log("error on user checkin");
            }
        },
        async onInit(promise) {
            try {
                await promise;
            } catch (error) {
                console.error(error);
            }
        },
        paintOutline(detectedCodes, ctx) {
            for (const detectedCode of detectedCodes) {
                const [firstPoint, ...otherPoints] = detectedCode.cornerPoints;
                ctx.strokeStyle = "red";
                ctx.beginPath();
                ctx.moveTo(firstPoint.x, firstPoint.y);
                for (const { x, y } of otherPoints) {
                    ctx.lineTo(x, y);
                }
                ctx.lineTo(firstPoint.x, firstPoint.y);
                ctx.closePath();
                ctx.stroke();
            }
        },
        async switchCamera(deviceId) {
            this.error = false;
            this.camera = deviceId;
        }
    },
    filters: {
        firstLetter: value => value.charAt(0),
        stateCity: registration => {
            const fields = registration.fields ? registration.fields : [];
            let state = fields.find(
                field => field.fieldMapping === "state"
            );
            state = state ? state.value : "";

            let city = fields.find(
                field => field.fieldMapping === "city"
            );
            city = city ? city.value : "";

            let stateCity = state;
            if (state.length && city.length) stateCity += ", ";
            stateCity += city;

            return stateCity;
        }
    }
};
</script>

<style>
#attendees p{
    margin: 0;
}

#attendees .attendee {
    height: 190px;
    margin-bottom: 20px;
}

#attendees .attendee .card, #attendees .attendee .card-body{
    height: 100%;
}

#attendees .attendee .el-dropdown{
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;

}
.primary-card{
    background-color: #2ca8ff5e;
}





.filter-grid{
    display: grid;
    gap: 15px;
    grid-template-columns: repeat(3, 1fr);
}

.filter-grid .el-select .el-input .el-input__inner{
    border-radius: 0;
    margin:0;
}

.bgblack{
    background-color: black !important;
}

</style>
